// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"CourseSideBar_contentWrapper__1hwym","active":"CourseSideBar_active__3cT-o"};